export default {
  dataFormatada (dt) {
    let data = new Date(dt)
    let dia = (data.getDate() < 10) ? '0' + data.getDate() : data.getDate()
    let mes = ((data.getMonth() + 1) < 10) ? '0' + (data.getMonth() + 1) : data.getMonth() + 1
    let ano = data.getFullYear()
    let hora = (data.getHours() === 0) ? '00' : data.getHours()
    let minuto = (data.getMinutes() === 0) ? '00' : data.getMinutes()
    return [dia, mes, ano].join('/') + ' ' + [hora, minuto].join(':')
  },
  dataWPFormatada (dt) {
    let data = dt.split('T')[0].split('-')
    let hora = dt.split('T')[1].split(':')
    return [data[2], data[1], data[0]].join('/') + ' ' + [hora[0], hora[1]].join(':')
  },
  trataMiniatura (imagem) {
    if (imagem.media_details.width < 300) {
      return imagem.media_details.sizes.full
    } else {
      return imagem.media_details.sizes.medium
    }
  },
  trataImagemFull (imagem) {
    if (imagem.media_details.width < 1200) {
      return imagem.media_details.sizes.full
    } else {
      return imagem.media_details.sizes['post-thumbnail']
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/utils.js